/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/purchase_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/purchase_remote_lookup_provider.rb) */
export const itemTypeSchema = z.strictObject({
  indexed_name: z.string(),
  name: z.string(),
  is_blocklisted: z.boolean(),
  is_deleted: z.boolean(),
  status: z.enum(["active", "blocklisted", "blocklisting", "deleted", "deleting"]),
  internal_id: common.objectId,
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/purchase_remote_lookup_provider.rb) */
export const itemTypeOutputSchema = z.object({
  indexed_name: z.string(),
  name: z.string(),
  is_blocklisted: z.boolean(),
  is_deleted: z.boolean(),
  status: z.enum(["active", "blocklisted", "blocklisting", "deleted", "deleting"]),
  internal_id: common.objectId,
});
